import { AscModal, AscSelectInput, AscButton } from "../";
import {
  userStatuses,
  IUserStatus,
  UserStatusType,
  SHARED_ADMIN_ROUTES,
} from "@ascendnow/shared";
import styles from "./AscBatchFilter.module.scss";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

interface IAscBatchFilterProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
}

export default function AscBatchFilter({
  visible,
  setVisible,
}: IAscBatchFilterProps) {
  const router = useRouter();
  const { studentStatus } = router.query;
  const [userStatus, setUserStatus] = useState<UserStatusType>(
    userStatuses[0].value
  );

  useEffect(() => {
    if (studentStatus) {
      setUserStatus(studentStatus as UserStatusType);
    }
  }, [studentStatus]);

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.filterModal}
      withBackground={false}
      header="Filters"
    >
      <div className={styles.filterWrapper}>
        <div className={styles.filter}>
          <label htmlFor="status" className={styles.filterLabel}>
            Student status
          </label>
          <AscSelectInput
            id="status"
            placeholder="Select a status"
            defaultValue={userStatus}
            onChange={(value) => setUserStatus(value as UserStatusType)}
          >
            {userStatuses.map((userStatus: IUserStatus) => (
              <AscSelectInput.Option
                key={userStatus.value}
                label={userStatus.label}
                value={userStatus.value}
              />
            ))}
          </AscSelectInput>
        </div>
        <div className={styles.filterButtons}>
          <AscButton
            type="button"
            variant="secondary"
            onClick={() => {
              router.push({
                pathname: SHARED_ADMIN_ROUTES.singleBatch(
                  router.query.batchId as string
                ),
                query: {
                  ...(router.query.addToBatch ? { addToBatch: true } : {}),
                },
              });
              setVisible(false);
            }}
          >
            Clear all
          </AscButton>
          <AscButton
            type="button"
            onClick={() => {
              router.replace({
                pathname: SHARED_ADMIN_ROUTES.singleBatch(
                  router.query.batchId as string
                ),
                query: {
                  ...router.query,
                  studentStatus: userStatus,
                },
              });
              setVisible(false);
            }}
          >
            See result
          </AscButton>
        </div>
      </div>
    </AscModal>
  );
}
